import { useField } from 'formik';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { useTranslation } from 'react-i18next';
import * as graphql from 'generated/graphql';
import { Heading, Paragraph, QuillText, Tags } from '@treams/treams-ui';
import styled from 'styled-components';

const InlineSelect = styled(Tags.Item.Select)`
	display: inline-block;
`;

export default function CompetencyLevelPicker() {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [{ value }, , { setValue }] = useField<graphql.CompetencyGoal>('competency');

	const query = graphql.useCompetencyQuery({
		variables: { id: value?.competency.id },
		skip: !value,
	});

	if (!value) {
		return null;
	}

	const levels = value.competency.levels ?? query.data?.competency.levels;

	if (!levels) {
		return <Tags.Item.Skeleton label={t('goals.show.competencyLevel.label')} />;
	}

	return (
		<InlineSelect
			label={t('goals.show.competencyLevel.label')}
			options={levels
				?.filter(({ enabled }) => enabled)
				.map(({ level, criteria }) => ({
					value: level.id,
					title: localize(level.title).text,
					context: (
						<>
							<Heading>{localize(level.title).text}</Heading>
							<Paragraph mt={2}>
								<QuillText quill={localize(criteria ?? [])?.text} />
							</Paragraph>
						</>
					),
				}))}
			onChange={(newValue) => {
				const index = levels.findIndex(({ level }) => level.id === newValue);
				setValue({ competency: value.competency, competencyLevelIndex: index, appraisals: [] });
			}}
			selectedValue={levels?.[value.competencyLevelIndex].level.id}
		/>
	);
}
